import styled from 'styled-components'

import { TimeBarFillerProps } from '../types'

export const TimerBarFillerStyled = styled.div<TimeBarFillerProps>`
  animation: roundtime calc(${(props) => props.duration} * 1s) linear forwards;
  animation-play-state: ${(props) => (props.pause ? 'paused' : 'running')};

  @keyframes roundtime {
    from {
      transform: scaleY(0);
    }
    to {
      transform: scaleY(1);
    }
  }
`
